import { StrapiError, StrapiResponse } from '@/types';

export const GET = async (URL: string): Promise<any | StrapiError> => {
  try {
    const response = await fetch(URL, {
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-cache',
    });
    if (!response.ok) {
      throw await response.json();
    }
    return await response.json();
  } catch (error) {
    const strapiError = error as StrapiError;

    return { error: strapiError?.error?.message };
  }
};

export const POST = async (URL: string, data: any): Promise<any | StrapiError> => {
  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const { error } = (await response.json()) as StrapiError;
      console.log('##########', error, 'fetch helpers ------- POST', '##########');

      throw new Error(error.message);
    }

    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      return { error: error.message };
    }
  }
};

export const PUT = async (URL: string, data: any): Promise<any | StrapiError> => {
  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },

      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const { error } = await response.json();
      console.log('##########', error, 'fetch helpers ------- POST', '##########');

      throw new Error(error.status);
    }

    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      return { error: error.message };
    }
  }
};
